import React from "react"

import styled from "styled-components"

const StyledContentBlockWrapper = styled.div`
  width: 100%;
  background-color: ${props => props.backgroundColor};
`
const StyledContentBlock = styled.div`
  max-width: 1160px;
  & h2 {
    margin-bottom: 36px;
  }
  @media (min-width: 768px) {
    margin: auto;

    & h2 {
      margin-bottom: 40px;
      max-width: 760px;
    }
    & p {
      max-width: 860px;
    }
  }
  display: flex;
  flex-direction: column;

  & {
    padding: 56px 20px;

    @media (min-width: 768px) {
      padding: 104px 20px;
    }
  }
`

const ContentBlock = ({ backgroundColor = "white", children }) => {
  return (
    <StyledContentBlockWrapper backgroundColor={backgroundColor}>
      <StyledContentBlock>{children}</StyledContentBlock>
    </StyledContentBlockWrapper>
  )
}

export default ContentBlock
